import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Button, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import NoticesServices from "../../../services/NoticesService";
import moment from "moment";

@inject("store")
@inject("routes")
@observer
export default class Hero extends Component {
  constructor(props) {
    super(props);
    this.store = this.props.store;
    this.controller = this.props.controller;
    this.routes = this.props.routes;
    this.appStore = this.props.store.appStore;
    this.state = {
      notices: [],
    };
  }

  componentDidMount() {
    new NoticesServices().getBarraNotificacoes().then(({ data }) => {
      if (data && Array.isArray(data) && data.length > 0) {
        this.setState({ notices: data });
      }
    });
  }

  render() {
    const { notices } = this.state;
    return ( <span>
      {notices.map((notice) => (
        <div classlist="alert alert-info" role="alert">
          <b>{notices[0].Title}</b>
          {notices[0].Body && <span classlist="disabled"> - </span>}
          {notices[0].Body && <span classlist="disabled"> <a id="Popover1" type="button" onClick={this.controller.toggleNotificacao}>
            Ver mais [+]
          </a></span>}
          {notices[0].Body &&
          <Popover placement="bottom" isOpen={this.controller.notificacaoAberta} target="Popover1" toggle={this.controller.toggleNotificacao}>
            <PopoverBody><div dangerouslySetInnerHTML={{ __html: notices[0].Body }}></div></PopoverBody>
          </Popover>
          }
          <span classlist="disabled"> - <i>Postado em: {moment(notices[0].PublishAt).format("DD/MM/YYYY")}</i></span>
        </div>
      ))}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/BarraNotificacoes.js